import { Breakpoints } from '@/GlobalStyles';
import { useWindowDimensions } from 'react-native';
import { ListType } from '@/components/Contexts/ConfigurationContext';

const useNumberOfColumns = (listType: ListType, isGreatContainer: boolean = false) => {
  const { width } = useWindowDimensions();
  const numberOfColumns =
    width >= Breakpoints.tablet && listType === 'card'
      ? width >= 1024
        ? isGreatContainer
          ? 3
          : 2
        : 2
      : 1;
  return numberOfColumns;
};

export default useNumberOfColumns;
